<div class="flex flex-col gap-3">
    <div class="flex flex-col gap-3 p-3 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-0 dark:bg-surface-900 max-w-md">
        <div class="flex items-center gap-2 text-xs min-w-0">
            @if (faviconUrl()) {
                <img
                    [src]="faviconUrl()"
                    alt=""
                    class="w-4 h-4 rounded-sm object-contain flex-shrink-0"
                    referrerpolicy="no-referrer"
                    (error)="$any($event.target).style.display='none'"
                />
            } @else {
                <i class="pi pi-globe text-muted-color text-sm flex-shrink-0"></i>
            }
            <a
                [href]="url()"
                target="_blank"
                rel="noopener noreferrer"
                class="text-blue-500 hover:underline truncate"
            >
                {{ url() }}
            </a>
        </div>

        <div class="font-semibold text-base leading-snug line-clamp-2">{{ displayTitle() }}</div>

        <div class="text-sm text-muted-color line-clamp-2">{{ displayDescription() }}</div>

        <div class="aspect-[1.91/1] w-full rounded-md overflow-hidden bg-surface-100 dark:bg-surface-800 flex items-center justify-center text-xs text-muted-color">
            @if (ogUrl(); as src) {
                @if (imageState() === 'error') {
                    <span class="px-3 text-center">
                        <i class="pi pi-image-slash mr-1"></i>
                        Could not load image at this URL.
                    </span>
                } @else {
                    <img
                        [src]="src"
                        alt="Social preview"
                        class="w-full h-full object-cover"
                        referrerpolicy="no-referrer"
                        (load)="onImageLoad($event)"
                        (error)="onImageError()"
                    />
                }
            } @else {
                <span class="px-3 text-center">
                    No og:image set — link previews will fall back to the platform default.
                </span>
            }
        </div>
    </div>

    @if (ogWarning(); as warn) {
        <div class="flex items-start gap-2 text-xs text-yellow-600 dark:text-yellow-400 max-w-md">
            <i class="pi pi-exclamation-triangle mt-0.5"></i>
            <span><b>og:image</b> — {{ warn }}.</span>
        </div>
    }
</div>
